import type { CurrentPlan } from '../../../types/data';

export const currentPlanHeaders = [
  'name',
  'type',
  'dosage',
  'dosage_units',
  'timing',
  'frequency_interval',
  'doses_per_interval',
  'days_on',
  'days_off',
  'duration_period',
  'duration_repeat',
  'notes',
  'dosage_level',
  'dosage_type',
  'source',
  'start_date',
  'enabled',
] as const;

export const toCSV = (plan: CurrentPlan): Record<string, string> => ({
  name: plan.name,
  type: plan.type,
  dosage: plan.dosage?.toString() ?? '',
  dosage_units: plan.dosage_units ?? '',
  timing: plan.timing,
  frequency_interval: plan.frequency_interval,
  doses_per_interval: String(plan.doses_per_interval ?? ''),
  days_on: plan.days_on?.toString() ?? '',
  days_off: plan.days_off?.toString() ?? '',
  duration_period: plan.duration_period,
  duration_repeat: plan.duration_repeat ?? '',
  notes: plan.notes ?? '',
  dosage_level: plan.dosage_level ?? '',
  dosage_type: plan.dosage_type ?? '',
  source: plan.source ?? '',
  start_date: plan.start_date,
  enabled: String(plan.enabled ?? false)
});

export const fromCSV = (row: Record<string, string>): Partial<CurrentPlan> => ({
  name: row.name,
  type: row.type as CurrentPlan['type'],
  dosage: row.dosage ? parseFloat(row.dosage) : undefined,
  dosage_units: row.dosage_units || undefined,
  timing: row.timing as CurrentPlan['timing'],
  frequency_interval: row.frequency_interval,
  doses_per_interval: row.doses_per_interval,
  days_on: row.days_on ? parseInt(row.days_on, 10) : undefined,
  days_off: row.days_off ? parseInt(row.days_off, 10) : undefined,
  duration_period: row.duration_period,
  duration_repeat: row.duration_repeat || undefined,
  notes: row.notes || undefined,
  start_date: row.start_date,
  enabled: row.enabled,
  dosage_level: row.dosage_level || undefined,
  dosage_type: row.dosage_type || undefined,
  source: row.source || undefined
});